import React, { useEffect, useRef, useState } from 'react';
import {
  Container,
  Menu,
  MenuItem,
  StyledSVGButton,
  ToolTip,
} from '@/components/Approval/CategoryContent/TooltipBox/styles';
import { useFavoritesModal } from '@/components/Approval/RightContainer/Favorites/useFavoritesModal';
import useDeleteItem from '@/components/Approval/CategoryContent/TooltipBox/useDeleteItem';
import { t } from 'i18next';
import { useSnackbar } from '@/hooks/global-tools';
import { PAGE_URL } from '@/constant/url';

type P = {
  modifyItem: { title: string; id: string };
  isHovered: boolean;
  handleHoverClose(): void;
};

const TooltipBox = ({ modifyItem, isHovered, handleHoverClose }: P) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const toast = useSnackbar();

  const { FavoriteModal, openModal } = useFavoritesModal({
    handleClose: handleHoverClose,
    modifyItem,
  });

  const { DeleteModal, openModal: openDeleteModal } = useDeleteItem({
    title: modifyItem.title,
    favoriteId: modifyItem.id,
    handleClose: handleHoverClose,
  });

  const handleToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      setOpen(false);
    }
  };

  const onGetLink = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    toast?.show({ message: t('링크가 복사되었습니다.'), severity: 'success' });
    const link = `${process.env.NEXT_PUBLIC_ORIGIN_URL}${PAGE_URL.WORK_APPROVAL}&favoriteId=${modifyItem.id}`;
    navigator.clipboard.writeText(link);
    setOpen(false);
  };

  const onModify = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setOpen(false);
    openModal();
  };
  const onDelete = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setOpen(false);
    openDeleteModal();
  };

  useEffect(() => {
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  return (
    <Container>
      <StyledSVGButton onClick={(e) => handleToggle(e)}>
        <ToolTip className={isHovered || open ? 'active' : ''} />
      </StyledSVGButton>
      {open && (
        <Menu ref={menuRef}>
          <MenuItem onClick={(e) => onGetLink(e)}>{t('링크 복사')}</MenuItem>
          <MenuItem onClick={(e) => onModify(e)}>
            {t('내 필터 이름 수정')}
          </MenuItem>
          <MenuItem style={{ color: 'red' }} onClick={(e) => onDelete(e)}>
            {t('내 필터 삭제')}
          </MenuItem>
        </Menu>
      )}
      {FavoriteModal}
      {DeleteModal}
    </Container>
  );
};

export default TooltipBox;
